
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ReportLoading: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center py-8">
      <div className="animate-pulse text-gray-500">{t('reports.loading')}</div>
    </div>
  );
};
